export const defaultProps = {
  initialSlide: 0,
  maxScale: 4,
  minScale: 1,
  slideIndicatorTimeout: 5000,
  activeDotColor: '#4e99e9',
  dotColor: '#dadbdc',
}
